/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { BitSet } from '@gh/core-data';

export enum SystemRoleBit {
  Corporate = 0,
  Master = 1,
  Franchisee = 2,
  Estimator = 3,
  Supervisor = 4,
  JobAdmin = 5,
  Accountant = 6,
  SalesPerson = 7,
}

export const SYSTEM_ROLES_BIT_SIZE = 64;

export const systemRolesBitSet = (bit: SystemRoleBit) =>
  new BitSet(SYSTEM_ROLES_BIT_SIZE, (1 << bit).toString(16)); // tslint:disable-line:no-magic-numbers no-bitwise
